import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('credit-processes', storeModule.createStoreModule('credit-processes'))
